import React, { useState, useEffect, useRef, useCallback } from "react";
import { Typography, Box, Chip, Dialog, Switch, FormControlLabel, ToggleButtonGroup, ToggleButton, Checkbox } from '@mui/material';
import * as taskTemplateStyle from 'mui-components/kart/fieldmap/tasktemplates/TaskTemplateStyle';
import * as toggleButtonGroupStyle from 'mui-components/kart/fieldmap/tasktemplates/ToggleButtonGroupStyle';
import AddVehicleModal from 'mui-components/kart/fieldmap/vehicleModals/AddVehicleModal';
import AddEquipmentModal from 'mui-components/kart/fieldmap/vehicleModals/AddEquipmentModal';
import MuiTextField from 'components/mui3-forms/MuiTextField';
import MuiDatePicker from 'components/mui3-forms/MuiDatePicker';
import MuiSelectDropdown from 'components/mui3-forms/MuiSelectDropdown';
import MuiCollapseComponent from 'components/mui3-forms/MuiCollapseComponent';
import MuiNestedSubDropDown from "components/mui3-forms/MuiNestedSubDropdown";
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import { FormattedMessage } from 'react-intl';
import { createSvgIcon } from '@mui/material/utils';
import IntegratedPlantProtectionJournal from 'mui-components/kart/fieldmap/IntegratedPlantProtectionJournal';
import AddTaskWaterJournalTemplate1 from "./AddTaskWaterJournalTemplate1";
import AddTaskWaterJournalTemplate2 from "./AddTaskWaterJournalTemplate2";
import AddTaskTemplateNonWaterJournal from "./AddTaskNonWaterJournalTemplate";
import get from 'lodash/get';
import _ from 'lodash';
import TimerModal from 'mui-components/kart/fieldmap/tasktemplates/TimerModal';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import isEqual from 'lodash.isequal';

const ToggleMF = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 52,
  height: 32,
  padding: 0,
  position: 'relative',
  '&:hover .MuiSwitch-thumb': {
    backgroundColor: '#3F4949', // Thumb color change on hover
  },
  '& .MuiSwitch-switchBase': {
    padding: 0,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#ffffff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#005A5C' : '#00696D',
        opacity: 1,
        border: 0,
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: '#FFFFFF',
        width: 24,
        height: 24,
        marginTop: '4px',
        marginRight: '3px',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
      },
      '&:hover .MuiSwitch-thumb': {
        backgroundColor: '#6FF6FC', // Thumb color change on hover
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #00696D',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: '#BDBDBD',
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 16,
    height: 16,
    marginTop: '8px',
    marginLeft: '8px',
    backgroundColor: '#6F7979',
    position: 'relative', // Ensure pseudo-element is positioned correctly
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '32px', // Default size for the grey circle
      height: '32px', // Default size for the grey circle
      backgroundColor: 'rgba(128, 128, 128, 0.3)', // Grey transparent background
      borderRadius: '50%', // Ensure the grey circle is fully rounded
      transform: 'translate(-50%, -50%)',
      opacity: 0,
      transition: 'opacity 0.2s ease-in-out, width 0.2s, height 0.2s', // Smooth size transition
    },
  },
  '&:hover .MuiSwitch-track': {
    backgroundColor: '#D3D3D3', // Change background when hovering anywhere on switch
    borderRadius: '100px', // Keep the track background rounded
  },
  '& .MuiSwitch-track': {
    borderRadius: '100px', // Ensure the track is rounded
    backgroundColor: '#E6E9E8',
    border: '3px solid #6F7979',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 300,
    }),
  },
}));

const TickMark = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
    <path d="M7.51379 12.1284L4.38629 9.00086L3.32129 10.0584L7.51379 14.2509L16.5138 5.25086L15.4563 4.19336L7.51379 12.1284Z" fill="#041F21" />
  </svg>,
  'TickMark'
);


const AddTaskTemplate3 = (props) => {
  const { intl, activeFarm, selectedFields, selectedActivity, taskDetails, closeNewTask, createdVehicleId, createdEquipmentId, fieldMasterData, activitiesCommon, taskKartToggle, saveNewTask, userRegulations, userInfo, fieldDetails, filteredTask = null, isEditMode } = props;
  let growthStageDropdowns = _.filter(activitiesCommon, ['activityId', 'act19'])[0].dropdowns[3].elements;

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const allSelectedFieldIds = selectedFields.flatMap(sel => sel.fieldId || []); // flatten all fieldIds
  const selectedCropIds = allSelectedFieldIds.map(fieldId => {
    const matchedField = fieldDetails?.data1?.fields?.find(f => f.fieldId === fieldId);
    return matchedField?.cropId || null;
  }).filter(Boolean);

  // Check if all selected cropIds are the same
  let cropForSelectedField = null;
  if (
    selectedCropIds.length > 0 &&
    selectedCropIds.every(cropId => cropId === selectedCropIds[0])
  ) {
    cropForSelectedField = fieldMasterData?.cropList?.find(c => c.id === selectedCropIds[0])?.name || null;
  }

  const initialFormState = {
    farmId: activeFarm.farm.id,
    activityId: selectedActivity?.id,
    fieldIds: selectedFields[0]?.fieldId,
    activityName: selectedActivity?.activityName,
    vehicleAssetId: null,
    equipmentAssetId: null,
    startTime: new Date(new Date().setHours(0, 0, 0, 0)),
    weather: null,
    status: null,
    visibility: null,
    waterJournalAdded: false,
    note: null,
    waterJournal: {
      sprayerType: null,
      lessThan2PCSlope: null,
      reqdVegetatedBufferZone: null,
      nozzleName: null,
      developmentStage: null,
      reqdDistanceToSurfaceWater: null,
      fogSprayerModel: null,
      nozzlesProvideTargetMovement: false,
      damperSetForOptimalDistribution: false,
      oneEndClosedToAvoidSurfaceWater: false,
      sprayingTechnique: false,
      vegetatedBufferExists: false,
      bufferZonePlacement: null,
      locationAndDistance: null,
      distanceOfSurfaceWaterExists: false,
      distanceOfSurfaceWater: null,
      vegitatedBufferZone: false,
      distanceOfVegitagedBufferZone: null,
      windSpeed3: null,
      sprayingIntoCrop: false,
      equipmentModel: null,
      distanceToWaterBody: null,
      distanceToWaterWell: null,
      driftReduction: null,
      maxDrivingSpeed: null,
      pressure: null,
      nozzleHeight: null,
      cultureBySpray: null,
      fieldAge: null,
      amount: null,
      ptoSpeed: null,
      airSpeed: null,
      sprayingTechniqueMeter: null,
      nozzleFactory: null
    },
    taskActivity: {
      activityId: null,
      activityName: null,
      effectApplication: null,
      growthStage: null,
      growthStageSub: null,
      growthStageSubSubType: null,
      pestSubList: [],
      pestData: null,
      crop: cropForSelectedField,
      windSpeed: null,
      reason: null,
      firstHarvestDate: null,
      harvestDate: formatDate(new Date(new Date().setHours(0, 0, 0, 0))),
      pesticideType: [],
      performedBy: null,
      waterUnit: null,
      waterAmount: null
    },
    perField: false,
    updatable: true,
    timerHour: 0,
    timerMinutes: 0
  }
  const [formState, setFormState] = useState(initialFormState);
  const [formErrors, setFormErrors] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [showAddVehicleDialog, setShowAddVehicleDialog] = useState(false);
  const [showAddEquipmentDialog, setShowAddEquipmentDialog] = useState(false);
  const [isWaterJournalAdded, setIsWaterJournalAdded] = useState(false);
  const initialStateRef = useRef(initialFormState);
  const [selectedValue, setSelectedValue] = useState("FIELD_SPRAYER");
  const isFirstSelected = selectedValue === 'first';
  const isSecondSelected = selectedValue === 'second';
  const [isJournalOpen, setIsJournalOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isAtLeastOneModalCheckboxSelected, setIsAtLeastOneModalCheckboxSelected] = useState(false);
  const [allModalCheckboxesSelected, setAllModalCheckboxesSelected] = useState(false);
  const [hasConfirmedRegulations, setHasConfirmedRegulations] = useState(false);
  const [notSelectedError, setNotSelectedError] = useState(false);
  const [isTimerOpen, setTimerOpen] = useState(false);
  const [timerHourValue, setTimerHourValue] = useState(`${String('0').padStart(2, '0')}`);
  const [timerMinutesValue, setTimerMinutesValue] = useState(`${String('0').padStart(2, '0')}`);
  const [hasChanges, setHasChanges] = useState(false);
  const changeDetectedRef = useRef(false);
  const { isFailure, errorMessage, isSuccess } = taskDetails;

  useEffect(() => {
    const isDifferent = !isEqual(formState, initialStateRef.current);

    if (isDifferent && !changeDetectedRef.current) {
      changeDetectedRef.current = true;
      setHasChanges(true);
    }
  }, [formState]);

  useEffect(() => {
    if (createdVehicleId !== null) {
      setFormState((prevState) => {
        const updatedFormState = {
          ...prevState,
          vehicleAssetId: createdVehicleId
        };
        initialStateRef.current = updatedFormState;
        return updatedFormState;
      });
    }
  }, [createdVehicleId]);

  useEffect(() => {
    if (createdEquipmentId !== null) {
      setFormState((prevState) => {
        const updatedFormState = {
          ...prevState,
          equipmentAssetId: createdEquipmentId
        };
        initialStateRef.current = updatedFormState;
        return updatedFormState;
      });
    }
  }, [createdEquipmentId]);

  useEffect(() => {
    setSelectedValue('first');
  }, []);

  useEffect(() => {
    if (taskKartToggle?.getTaskList?.taskActivity) {
      setFormState((prevState) => {
        const commonFields = {
          ...prevState,
          locationId: taskKartToggle.getTaskList.taskActivity.locationId || null,
          weather: taskKartToggle.getTaskList.weather || null,
          vehicleAssetId: taskKartToggle.getTaskList.vehicleAssetId || null,
          equipmentAssetId: taskKartToggle.getTaskList.equipmentAssetId || null,
        };

        const updatedFormState = taskKartToggle.getTaskList.waterJournal
          ? {
            ...commonFields,
            waterJournal: {
              ...prevState.waterJournal,
              ...taskKartToggle.getTaskList.waterJournal,
              sprayerType: taskKartToggle.getTaskList.waterJournal?.sprayerType || 'FIELD_SPRAYER',
            },
            waterJournalAdded: true,
          }
          : {
            ...commonFields
          };

        const reverseSprayerMap = {
          FIELD_SPRAYER: 'first',
          FOG_SPRAYER: 'second',
        };
        const sprayerType = taskKartToggle.getTaskList.waterJournal?.sprayerType;
        const selectedValue = reverseSprayerMap[sprayerType] || 'first';

        initialStateRef.current = updatedFormState;
        setSelectedValue(selectedValue);

        return updatedFormState;
      });
    }
  }, [taskKartToggle]);

  useEffect(() => {
    if (formState.waterJournalAdded && !formState.waterJournal?.sprayerType) {
      setFormState((prev) => ({
        ...prev,
        waterJournal: {
          ...prev.waterJournal,
          sprayerType: 'FIELD_SPRAYER',
        },
      }));
    }
  }, [formState.waterJournalAdded]);


  useEffect(() => {
    if (filteredTask) {
      // Helper function for robust boolean conversion
      const toBooleanOrNull = (value) => {
        if (value === true || value === 'true') {
          return true;
        }
        if (value === false || value === 'false') {
          return false;
        }
        return null;
      };

      setFormState((prevState) => {

        const taskActivityPestData = filteredTask?.taskActivity?.pestData || null;
        const taskActivityPestSubList = filteredTask?.taskActivity?.pestSubList || [];

        const taskActivityGrowthStage = filteredTask?.taskActivity?.growthStage || null;
        const taskActivityGrowthStageSub = filteredTask?.taskActivity?.growthStageSub || null;
        const taskActivityGrowthStageSubSubType = filteredTask?.taskActivity?.growthStageSubSubType || null;

        const commonFields = {
          ...prevState,
          startTime: filteredTask?.endTime,
          note: filteredTask?.notes || null,
          weather: filteredTask?.weather || null,
          vehicleAssetId: filteredTask?.vehicleAssetId || null,
          equipmentAssetId: filteredTask?.equipmentAssetId || null,
          timerHour: filteredTask?.netDuration > 0 && Math.floor(filteredTask?.netDuration / 3600),
          timerMinutes: filteredTask?.netDuration > 0 && Math.floor((filteredTask?.netDuration % 3600) / 60)
        };

        const updatedFormState = filteredTask?.waterJournalAdded
          ? {
            ...commonFields,
            taskActivity: { // Build taskActivity, similar to handleFieldChange
              ...prevState.taskActivity, // Retain any existing taskActivity fields if needed
              crop: filteredTask?.taskActivity?.crop || null,
              firstHarvestDate: filteredTask?.taskActivity?.firstHarvestDate,
              effectApplication: filteredTask?.taskActivity?.effectApplication || null,
              reason: filteredTask?.taskActivity?.reason || null,
              waterAmount: filteredTask?.taskActivity?.waterAmount || null,
              waterUnit: filteredTask?.taskActivity?.waterUnit || null,
              windSpeed: filteredTask?.taskActivity?.windSpeed || null,
              growthStage: taskActivityGrowthStage,
              growthStageSub: taskActivityGrowthStageSub,
              growthStageSubSubType: taskActivityGrowthStageSubSubType,
              pestData: taskActivityPestData,
              pestSubList: taskActivityPestSubList,
              performedBy: filteredTask.taskActivity?.performedBy || null
            },
            waterJournalAdded: filteredTask?.waterJournalAdded,
            waterJournal: {
              ...filteredTask.waterJournal, // Spread existing waterJournal to retain other fields
              sprayerType: filteredTask?.waterJournal?.sprayerType || 'FIELD_SPRAYER',
              equipmentModel: filteredTask?.waterJournal?.equipmentModel,
              lessThan2PCSlope: toBooleanOrNull(filteredTask?.waterJournal?.lessThan2PCSlope),
              nozzlesProvideTargetMovement: toBooleanOrNull(filteredTask?.waterJournal?.nozzlesProvideTargetMovement),
              damperSetForOptimalDistribution: toBooleanOrNull(filteredTask?.waterJournal?.damperSetForOptimalDistribution),
              oneEndClosedToAvoidSurfaceWater: toBooleanOrNull(filteredTask?.waterJournal?.oneEndClosedToAvoidSurfaceWater),
              sprayingTechnique: toBooleanOrNull(filteredTask?.waterJournal?.sprayingTechnique),
              vegetatedBufferExists: toBooleanOrNull(filteredTask?.waterJournal?.vegetatedBufferExists),
              distanceOfSurfaceWaterExists: toBooleanOrNull(filteredTask?.waterJournal?.distanceOfSurfaceWaterExists),
              vegitatedBufferZone: toBooleanOrNull(filteredTask?.waterJournal?.vegitatedBufferZone),
              sprayingIntoCrop: toBooleanOrNull(filteredTask?.waterJournal?.sprayingIntoCrop),
            }
          }
          : {
            ...commonFields,
            taskActivity: { // Ensure taskActivity is included even if no waterJournal
              ...prevState.taskActivity,
              crop: filteredTask?.taskActivity?.crop || null,
              firstHarvestDate: filteredTask?.taskActivity?.firstHarvestDate,
              effectApplication: filteredTask?.taskActivity?.effectApplication || null,
              reason: filteredTask?.taskActivity?.reason || null,
              waterAmount: filteredTask?.taskActivity?.waterAmount || null,
              waterUnit: filteredTask?.taskActivity?.waterUnit || null,
              windSpeed: filteredTask?.taskActivity?.windSpeed || null,
              performedBy: filteredTask?.taskActivity?.performedBy || null,
              growthStage: taskActivityGrowthStage,
              growthStageSub: taskActivityGrowthStageSub,
              growthStageSubSubType: taskActivityGrowthStageSubSubType,
              pestData: taskActivityPestData,
              pestSubList: taskActivityPestSubList
            }
          };
        setIsWaterJournalAdded(filteredTask?.waterJournalAdded);
        setTimerHourValue(`${String(filteredTask?.netDuration > 0 && Math.floor(filteredTask?.netDuration / 3600) || '0').padStart(2, '0')}`);
        setTimerMinutesValue(`${String(filteredTask?.netDuration > 0 && Math.floor((filteredTask?.netDuration % 3600) / 60) || '0').padStart(2, '0')}`);
        const pesticideArray = filteredTask?.taskActivity?.pesticideType || [];
        updatedFormState.pesticideType = pesticideArray.map(item => item.name || '');
        pesticideArray && pesticideArray.forEach((item, index) => {
          updatedFormState[`pesticideType.${index}.amount`] = item.amount || '';
          updatedFormState[`pesticideType.${index}.unit`] = item.unit || '';
        });

        const reverseSprayerMap = {
          FIELD_SPRAYER: 'first',
          FOG_SPRAYER: 'second',
        };
        const sprayerType = filteredTask?.waterJournal?.sprayerType;
        const selectedValue = reverseSprayerMap[sprayerType] || 'first';

        initialStateRef.current = updatedFormState;
        setSelectedValue(selectedValue);

        return updatedFormState;
      });
    }
  }, [filteredTask]);

  useEffect(() => {
    if (userRegulations?.regulationList?.length) {
      const atLeastOneSelected = userRegulations.regulationList.some(item => item.opted);
      setIsChecked(atLeastOneSelected);
      setHasConfirmedRegulations(atLeastOneSelected); // Ensure this is also set correctly
      const allSelected = userRegulations.regulationList.every(item => item.opted);
      setAllModalCheckboxesSelected(allSelected);
      setIsAtLeastOneModalCheckboxSelected(atLeastOneSelected);
    } else {
      setIsChecked(false);
      setHasConfirmedRegulations(false);
      setAllModalCheckboxesSelected(false);
      setIsAtLeastOneModalCheckboxSelected(false);
    }
  }, [userRegulations]);

  const handleOpenJournal = () => {
    setIsJournalOpen(true);
  };

  const handleCloseJournal = () => {
    setIsJournalOpen(false);
  };

  const handleRegulationsCheckboxChangeFromModal = useCallback(
    (atLeastOneSelected, allSelected) => {
      setIsAtLeastOneModalCheckboxSelected(atLeastOneSelected);

      if (allSelected) {
        setIsChecked(true);
      } else if (atLeastOneSelected) {
        setIsChecked('mixed'); // Use 'mixed' for intermediate state
        setHasConfirmedRegulations(true);
      } else {
        setIsChecked(false);
        setHasConfirmedRegulations(false);
      }

      setAllModalCheckboxesSelected(allSelected);
    },
    [] // Add dependencies here only if needed
  );

  const handleCancel = () => {
    let isChanged = JSON.stringify(initialStateRef.current) !== JSON.stringify(formState);
    if (isChanged || hasChanges && isEditMode) {
      setModalOpen(true);
    } else {
      handleCancelButton();
    }
  };

  const handleCancelButton = () => {
    setModalOpen(false);
    closeNewTask();
  };

  const onCloseVehicleDialog = () => {
    setShowAddVehicleDialog(false);
  }

  const onCloseEquipmentDialog = () => {
    setShowAddEquipmentDialog(false);
  }

  const handleToggleChange = (event) => {
    const newValue = event.target.checked;

    setFormState((prevState) => ({
      ...prevState,
      perField: !newValue,
      waterJournalAdded: newValue,
    }));

    setIsWaterJournalAdded(newValue);

    if (!newValue) {
      // Reset the selected button and sprayerType when toggle is turned OFF
      setSelectedValue('first');
      setFormState((prev) => ({
        ...prev,
        waterJournal: {
          ...prev.waterJournal,
          sprayerType: 'FIELD_SPRAYER',
        },
      }));
    }
  };

  const waterJournalFields = [
    "equipmentModel", "nozzleName", "pressure", "driftReduction", "maxDrivingSpeed", "airSpeed", "ptoSpeed", "amount", "sprayingTechniqueMeter", "nozzlesProvideTargetMovement",
    "oneEndClosedToAvoidSurfaceWater", "damperSetForOptimalDistribution", "fieldAge", "cultureBySpray", "distanceToWaterBody", "distanceToWaterWell", "vegetatedBufferExists",
    "bufferZonePlacement", "locationAndDistance", "distanceOfSurfaceWaterExists", "distanceOfSurfaceWater", "vegitatedBufferZone", "distanceOfVegitagedBufferZone", "nozzleFactory", "nozzleHeight", "lessThan2PCSlope", "windSpeed3", "sprayingIntoCrop",
    "sprayingTechnique"
  ];

  const handleFieldChange = (fieldName, value) => {
    // console.log(`[handleFieldChange]: ${fieldName}: ${value}`);
    const updatedValue = value !== "" ? value : null;

    if (fieldName === 'pestInfo' && typeof value === 'object' && value !== null) {
      const pestData = value.element?.trim();
      const pestSubList = Array.isArray(value.leaves) ? value.leaves.map(item => item.trim()) : [];

      setFormState(prevState => ({
        ...prevState,
        taskActivity: {
          ...prevState.taskActivity,
          pestData,
          pestSubList
        }
      }));
    } else if (fieldName === 'growthStageNested' && typeof value === 'object' && value !== null) {
      const { element, subElement, leaf } = value;

      const growthStage = element?.trim() || null;
      const growthStageSub = element === subElement ? (leaf?.trim() || null) : (subElement?.trim() || null);
      const growthStageSubSubType = element === subElement ? null : (leaf?.trim() || null);

      setFormState(prevState => ({
        ...prevState,
        taskActivity: {
          ...prevState.taskActivity,
          growthStage,
          growthStageSub,
          growthStageSubSubType,
        }
      }));
    } else if (fieldName === 'selectedValue') {
      const sprayerTypeMap = {
        first: 'FIELD_SPRAYER',
        second: 'FOG_SPRAYER',
      };

      setSelectedValue(updatedValue);

      setFormState((prevState) => ({
        ...prevState,
        waterJournal: {
          ...prevState.waterJournal,
          sprayerType: sprayerTypeMap[updatedValue],
        },
      }));
    } else if (fieldName === 'firstHarvestDate') {
      const date = new Date(value);
      const formattedDate = formatDate(date);

      setFormState((prevState) => ({
        ...prevState,
        taskActivity: {
          ...prevState.taskActivity,
          firstHarvestDate: date,
          harvestDate: formattedDate
        }
      }));
    } else if (['crop', 'effectApplication', 'reason', 'waterUnit', 'windSpeed', 'performedBy', 'timerHour', 'timerMinutes'].includes(fieldName)) {
      setFormState(prevState => ({
        ...prevState,
        taskActivity: {
          ...prevState.taskActivity,
          [fieldName]: updatedValue
        }
      }));
    } else {
      setFormState((prevState) => {
        if (waterJournalFields.includes(fieldName)) {
          return {
            ...prevState,
            waterJournal: {
              ...prevState.waterJournal,
              [fieldName]: updatedValue
            }
          };
        } else {
          return {
            ...prevState,
            [fieldName]: updatedValue
          };
        }
      });
    }
  };

  const handleNumericValidation = (fieldName, value) => {
    // console.log(`[handleNumericValidation] ${fieldName}: ${value}`);
    if (/^\d*([.,]?\d*)?$/.test(value)) {
      setFormState((prevState) => {
        // Check if the field exists in waterJournal
        const isWaterJournalField = prevState.waterJournal && fieldName in prevState.waterJournal;

        const isTaskActivityField = prevState.taskActivity && fieldName in prevState.taskActivity;
        if (isWaterJournalField) {
          return {
            ...prevState,
            waterJournal: {
              ...prevState.waterJournal,
              [fieldName]: value
            }
          };
        } else if (isTaskActivityField) {
          return {
            ...prevState,
            taskActivity: {
              ...prevState.taskActivity,
              [fieldName]: value
            }
          };
        }
        else {
          return {
            ...prevState,
            [fieldName]: value
          };
        }
      });

      setFormErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[fieldName];
        return newErrors;
      });
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: intl.formatMessage({ id: 'DYNAMIC_SECTION_AMOUNT_VAL_MSG' }),
      }));
    }
  };

  const handleSave = () => {
    // Prevent save if no regulation selected
    if (!isAtLeastOneModalCheckboxSelected) {
      setNotSelectedError(true);
      return;
    }
    setNotSelectedError(false);

    setModalOpen(false);
    let updatedFormState = { ...formState };

    if (!updatedFormState.waterJournalAdded) {
      updatedFormState.waterJournal = null;
    } else {
      const originalWaterJournal = updatedFormState.waterJournal || {};
      const defaultWaterJournal = {
        sprayerType: null,
        lessThan2PCSlope: null,
        reqdVegetatedBufferZone: null,
        nozzleName: null,
        nozzleFactory: null,
        developmentStage: null,
        reqdDistanceToSurfaceWater: null,
        fogSprayerModel: null,
        nozzlesProvideTargetMovement: false,
        damperSetForOptimalDistribution: false,
        oneEndClosedToAvoidSurfaceWater: false,
        sprayingTechnique: false,
        vegetatedBufferExists: false,
        bufferZonePlacement: null,
        locationAndDistance: null,
        distanceOfSurfaceWaterExists: false,
        distanceOfSurfaceWater: null,
        vegitatedBufferZone: false,
        distanceOfVegitagedBufferZone: null,
        windSpeed3: null,
        sprayingIntoCrop: false,
        equipmentModel: null,
        distanceToWaterBody: null,
        distanceToWaterWell: null,
        driftReduction: null,
        maxDrivingSpeed: null,
        pressure: null,
        nozzleHeight: null,
        cultureBySpray: null,
        fieldAge: null,
        amount: null,
        ptoSpeed: null,
        airSpeed: null,
        sprayingTechniqueMeter: null
      };

      // Remove dependent fields if controlling fields are false
      if (!originalWaterJournal.vegetatedBufferExists) {
        originalWaterJournal.bufferZonePlacement = null;
        originalWaterJournal.locationAndDistance = null;
      }
      if (!originalWaterJournal.distanceOfSurfaceWaterExists) {
        originalWaterJournal.distanceOfSurfaceWater = null;
      }
      if (!originalWaterJournal.vegitatedBufferZone) {
        originalWaterJournal.distanceOfVegitagedBufferZone = null;
      }

      const updatedWaterJournal = {
        ...defaultWaterJournal,
        ...originalWaterJournal,
      };

      updatedFormState.waterJournal = updatedWaterJournal;
    }

    // Transform pesticideType array
    if (Array.isArray(updatedFormState.pesticideType) && updatedFormState.pesticideType.length > 0) {
      const arrayPesticideType = updatedFormState.pesticideType.map((pesticide, index) => ({
        amount: get(updatedFormState, `pesticideType.${index}.amount`) || '',
        name: pesticide,
        unit: get(updatedFormState, `pesticideType.${index}.unit`) || ''
      }));

      updatedFormState.pesticideType = arrayPesticideType;
    }

    taskDetails.isFailure = false;
    taskDetails.errorMessage = '';

    if (filteredTask?.id) {
      updatedFormState.id = filteredTask.id;
      updatedFormState.status = filteredTask.status;
      saveNewTask(updatedFormState);
    } else if (formErrors && Object.values(formErrors).length === 0) {
      saveNewTask(updatedFormState);
    }
  };

  const AddVehicle = () => (
    <Box style={taskTemplateStyle.assetAdd} onClick={() => setShowAddVehicleDialog(true)}>
      <Box sx={{ padding: '5px 15px 0px 0px' }}>
        <AddIcon />
      </Box>
      <Typography style={taskTemplateStyle.assetAddHeader}>{intl.formatMessage({ id: 'CT_ANV' })}</Typography>
    </Box>
  );

  const vehicleOptions = () => {
    let vehicleList = [];
    vehicleList.push({ value: null, label: <AddVehicle /> });
    if (taskDetails.allVehicles && (taskDetails.allVehicles).length > 0) {
      (taskDetails.allVehicles).map(data => (
        vehicleList.push({
          value: data.asset.assetId,
          label: `${data.asset.brand} ${data.asset.model}`
        })
      ));
      return vehicleList;
    }
    return vehicleList;
  };

  const AddEquipment = () => (
    <Box style={taskTemplateStyle.assetAdd} onClick={() => setShowAddEquipmentDialog(true)}>
      <Box sx={{ padding: '5px 15px 0px 0px' }}>
        <AddIcon />
      </Box>
      <Typography style={taskTemplateStyle.assetAddHeader}>{intl.formatMessage({ id: 'CT_ANE' })}</Typography>
    </Box>
  );

  const equipmentOptions = () => {
    let equipmentList = [];
    equipmentList.push({ value: null, label: <AddEquipment /> });
    if (taskDetails.allEquipments && (taskDetails.allEquipments).length > 0) {
      (taskDetails.allEquipments).map(data => (
        equipmentList.push({
          value: data.asset.assetId,
          label: `${data.asset.brand} ${data.asset.model}`
        })
      ));
      return equipmentList;
    }
    return equipmentList;
  };

  // Water volume unit
  const waterUnitOptions = () => {
    const values = ['liter', 'liter/daa'];
    return values.map(value => ({
      value,
      label: value,
    }));
  }

  // Wind speed
  const getWindSpeedOptions = () => {
    return Array.from({ length: 20 }, (_, i) => {
      const value = (i + 1).toString();
      return {
        value,
        label: value,
      };
    });
  };

  // Weather options
  const weatherOptions = [
    { value: 'sunny', label: <FormattedMessage id="SUNNY" /> },
    { value: 'cloudy', label: <FormattedMessage id="CLOUDY" /> },
    { value: 'sun_and_rain', label: <FormattedMessage id="SUNANDRAIN" /> },
    { value: 'overcast', label: <FormattedMessage id="OVERCAST" /> },
    { value: 'rain', label: <FormattedMessage id="RAIN" /> },
  ];

  const handleAlignment = (event, newValue) => {
    if (!newValue) return;

    setSelectedValue(newValue);

    const sprayerTypeMap = {
      first: 'FIELD_SPRAYER',
      second: 'FOG_SPRAYER',
    };

    setFormState(prev => ({
      ...prev,
      waterJournal: {
        ...prev.waterJournal,
        sprayerType: sprayerTypeMap[newValue],
      }
    }));
  };

  useEffect(() => {
    // console.log("Current selectedValue: ", selectedValue);
  }, [selectedValue]); // This effect runs whenever selectedValue changes

  const handleContinueSave = () => {
    setModalOpen(false);
  };

  let growthStageValue = {
    element: formState.taskActivity?.growthStage || null,
    subElement: formState.taskActivity?.growthStageSub || null,
    leaf: formState.taskActivity?.growthStageSubSubType || null
  }

  const handleHoursChange = (fieldName, value) => {
    const hourRegex = /^\d*([.,]?\d*)?$/;
    if (value) {
      if (hourRegex.test(value)) {
        setFormState((prevState) => ({
          ...prevState,
          [fieldName]: value,
        }));
        setFormErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          delete newErrors[fieldName];
          return newErrors;
        });
      } else {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: intl.formatMessage({ id: 'invalid' }),
        }));
      }
    } else {
      setFormState((prevState) => ({
        ...prevState,
        [fieldName]: 0,
      }));
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: '',
      }));
    }
  };

  const handleMinutesChange = (fieldName, value) => {
    const hourRegex = /^([0-9]|0[0-9]|[1-5][0-9])$/;
    if (value) {
      if (hourRegex.test(value)) {
        setFormState((prevState) => ({
          ...prevState,
          [fieldName]: value,
        }));
        setFormErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          delete newErrors[fieldName];
          return newErrors;
        });
      } else {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: intl.formatMessage({ id: 'invalid' }),
        }));
      }
    } else {
      setFormState((prevState) => ({
        ...prevState,
        [fieldName]: 0,
      }));
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: '',
      }));
    }
  };

  const openTimerDialog = () => {
    setTimerOpen(true);
  }

  const handleCancelTimerButton = () => {
    if (timerHourValue !== '0' || timerHourValue !== '00') {
      formState.timerHour = parseInt(timerHourValue, 10);
    } else {
      formState.timerHour = null;
    }
    if (timerMinutesValue !== '0' || timerMinutesValue !== '00') {
      formState.timerMinutes = parseInt(timerMinutesValue, 10);
    } else {
      formState.timerMinutes = null;
    }
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      ['timerHour']: '',
      ['timerMinutes']: '',
    }));
    setTimerOpen(false);
  };

  const handleOkTimerButton = () => {
    setTimerHourValue(`${String(formState.timerHour || '0').padStart(2, '0')}`);
    setTimerMinutesValue(`${String(formState.timerMinutes || '0').padStart(2, '0')}`);
    setTimerOpen(false);
  }

  const startTimeToUse =
    filteredTask?.endTime
      ? new Date(filteredTask.endTime)
      : new Date(formState.startTime);

  return (
    <Box sx={{
      padding: '0px 24px 0px 24px',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '8px',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#A8A8A8',
        borderRadius: '4px',
        transition: 'background-color 0.3s ease',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#B8B8B8',
      }
    }}
    >
      <Box style={{ ...taskTemplateStyle.headerSticky, alignItems: 'flex-start', gap: '16px', alignSelf: 'stretch', paddingBottom: '0px' }}>
        <Box style={taskTemplateStyle.modalDialogHeader}>
          <Typography style={taskTemplateStyle.modalDialogTitle}>
            {selectedActivity?.activityName}
            <span style={{ ...taskTemplateStyle.mainSubHeadingStyle, paddingLeft: '16px' }}>
              ({intl.formatMessage({ id: 'SPRAY_JOURNAL_WATER_JOURNAL' })})
            </span>
          </Typography>
          {/*<Box sx={{ paddingRight: '10px' }}>
            <MuiChipDropdown
              defaultLabel={intl.formatMessage({ id: 'FIRST_HARVEST_YIELD' })}
              defaultValue={1}
              options={harvestOptions}
              optionStyle={taskTemplateStyle.menuOptionText}
              dropdownStyle={taskTemplateStyle.chipDropdownStyle}
              fieldName='cut'
              onChange={handleFieldChange}
            />
          </Box>*/}
        </Box>
        <Box style={taskTemplateStyle.modalDialogSubHeader}>
          <Typography style={taskTemplateStyle.modalDialogSubTitle}>{selectedFields[0].fieldName.join(", ") || filteredTask.fieldName}</Typography>
        </Box>
      </Box>
      <Box>
        <Box sx={taskTemplateStyle.alignmentStyleForTextAttributes}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              alignSelf: 'stretch',
              gap: 1,
            }}
          >
            <Box
              sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            >
              <Typography
                sx={taskTemplateStyle.profileRegulationsLinkText}
                onClick={handleOpenJournal}
              >
                {intl.formatMessage({ id: 'PROFILE_REGULATIONS_LINK' })}*
              </Typography>
              <Box sx={{ padding: '11px' }}>
                <Checkbox
                  sx={{
                    padding: '0 0 0 8px',
                    '&.Mui-checked': {
                      color: '#00696D',
                    },
                    '&.MuiCheckbox-indeterminate': { // Target the indeterminate state
                      color: '#00696D', // Set the color of the icon (hyphen)
                    },
                  }}
                  checked={isChecked === true}
                  indeterminate={isChecked === 'mixed'}
                  disabled={!hasConfirmedRegulations || !allModalCheckboxesSelected}
                />
              </Box>
            </Box>

            <IntegratedPlantProtectionJournal
              open={isJournalOpen}
              onClose={handleCloseJournal}
              onRegulationsCheckboxChangeFromModal={handleRegulationsCheckboxChangeFromModal}
              setNotSelectedError={setNotSelectedError}
              userRegulations={userRegulations} // Passing userRegulations as a prop
              userInfo={userInfo}
            />
          </Box>
        </Box>
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: '8px',
              width: '100%',
            }}
          >
            <FormControlLabel
              label={
                <Box sx={{ pointerEvents: 'none' }}>
                  <Typography sx={taskTemplateStyle.waterJournalTextStyle}>
                    {intl.formatMessage({ id: 'WATER_JOURNAL' })}
                  </Typography>
                </Box>
              }
              sx={{
                display: "flex",
                width: "100%",
                flexDirection: "row-reverse",
                marginRight: '6px !important',
              }}
              control={
                <ToggleMF
                  sx={{ m: 0 }}
                  checked={isWaterJournalAdded}
                  onChange={(e) => {
                    e.stopPropagation();
                    handleToggleChange(e);
                  }}
                />
              }
            />
          </Box>
        </Box>
      </Box>
      <Box sx={{ display: "flex", gap: '16px', paddingTop: '56px', alignItems: "center" }}>
        {/* Spray date */}
        <MuiDatePicker
          defaultLabel={intl.formatMessage({ id: 'DATE_OF_SPRAYING' })}
          dateFormat={"dd/MM/yyyy"}
          fieldName='startTime'
          onChange={handleFieldChange}
          maxDateOption={true}
          required={true}
          fullWidth={true}
          activityId="act19"
          defaultValue={startTimeToUse}
        />
        {/* First possible harvest date */}
        <MuiDatePicker
          defaultLabel={intl.formatMessage({ id: 'CT_FVHD' })}
          defaultValue={
            filteredTask?.taskActivity?.firstHarvestDate
              ? new Date(filteredTask?.taskActivity?.firstHarvestDate)
              : null
          }
          dateFormat={"dd/MM/yyyy"}
          fieldName='firstHarvestDate'
          onChange={handleFieldChange}
          maxDateOption={false}
          required={true}
          fullWidth={true}
          activityId="act19"
        />
      </Box>
      {
        isWaterJournalAdded && (
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", paddingTop: '56px' }}>
              <Typography style={taskTemplateStyle.textHeadingStyle}>
                {intl.formatMessage({ id: 'EQUIPMENT_USED' })}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", paddingTop: '24px' }}>
              <ToggleButtonGroup
                exclusive
                aria-label="text alignment"
                value={selectedValue}
                onChange={handleAlignment}
              >
                <ToggleButton
                  value="first"
                  style={selectedValue === 'first' ? toggleButtonGroupStyle.buttonFilledLeftStyle1 : toggleButtonGroupStyle.buttonFilledLeftStyle}
                  sx={{ width: '200px', justifyContent: 'flex-start' }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                    {selectedValue === 'first' ? (
                      <TickMark sx={{ fontSize: 18 }} />
                    ) : (
                      <Box sx={{ width: '18px', height: '18px' }} />
                    )}
                    <Typography
                      sx={{
                        ...(selectedValue === 'first' ? toggleButtonGroupStyle.selectedTextStyle : toggleButtonGroupStyle.unselectedTextStyle),
                        width: 'auto',
                      }}
                    >
                      {intl.formatMessage({ id: 'WATER_JOURNAL_EQUIPMENT_USED_OPTION1' })}
                    </Typography>
                  </Box>
                </ToggleButton>

                <ToggleButton
                  value="second"
                  style={selectedValue === 'second' ? toggleButtonGroupStyle.buttonFilledRightStyle1 : toggleButtonGroupStyle.buttonFilledRightStyle}
                  sx={{ width: '200px', justifyContent: 'flex-start' }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                    {selectedValue === 'second' ? (
                      <TickMark sx={{ fontSize: 18 }} />
                    ) : (
                      <Box sx={{ width: '18px', height: '18px' }} />
                    )}
                    <Typography
                      sx={{
                        ...(selectedValue === 'second' ? toggleButtonGroupStyle.selectedTextStyle : toggleButtonGroupStyle.unselectedTextStyle),
                        width: 'auto',
                      }}
                    >
                      {intl.formatMessage({ id: 'WATER_JOURNAL_EQUIPMENT_USED_OPTION2' })}
                    </Typography>
                  </Box>
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
            <Box sx={{ display: isFirstSelected ? 'block' : 'none' }}>
              <>
                <AddTaskWaterJournalTemplate1
                  onFieldChange={handleFieldChange}
                  formErrors={formErrors}
                  formData={formState}
                  initialData={initialFormState}
                  handleNumericValidation={handleNumericValidation}
                  intl={intl}
                  activeFarm={activeFarm}
                  selectedFields={selectedFields}
                  selectedActivity={selectedActivity}
                  taskDetails={taskDetails}
                  createdVehicleId={createdVehicleId}
                  createdEquipmentId={createdEquipmentId}
                  fieldMasterData={fieldMasterData}
                  activitiesCommon={activitiesCommon}
                  taskKartToggle={taskKartToggle}
                  waterJournal={formState.waterJournal}
                />
                <Box sx={{ display: "flex", alignItems: "center", paddingTop: '56px' }}>
                  <MuiCollapseComponent
                    title={intl.formatMessage({ id: 'TASK_MORE_INFORMATION_OPTIONAL' })}
                    content={
                      <Box sx={{ marginTop: '48px', width: '100%' }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <MuiTextField
                            defaultLabel={intl.formatMessage({ id: 'TIME_SPENT' })}
                            defaultValue={`${timerHourValue} : ${timerMinutesValue}`}
                            inputAdornment={<AccessTimeIcon />}
                            position="start"
                            fieldName='timeSpent'
                            autoFocus={false}
                            onClick={openTimerDialog}
                            readOnly={true}
                            activityId="act19"
                          />
                        </Box>
                        {/* Water amount and water unit */}
                        <Box sx={{ display: "flex", gap: '16px', alignItems: "center", paddingTop: '32px' }}>
                          <MuiTextField
                            defaultLabel={intl.formatMessage({ id: 'CT_WATERAMOUNT' })}
                            defaultValue={formState.taskActivity?.waterAmount || ''}
                            fieldName='waterAmount'
                            onChange={handleNumericValidation}
                            autoFocus={false}
                            errorHelperText={formErrors['waterAmount']}
                            activityId="act19"
                          />
                          <MuiSelectDropdown
                            defaultLabel={intl.formatMessage({ id: 'WATER_VOLUME_UNIT' })}
                            defaultValue={formState.taskActivity?.waterUnit || ''}
                            options={waterUnitOptions()}
                            fieldName='waterUnit'
                            onChange={handleFieldChange}
                            autoFocus={false}
                            activityId="act19"
                          />
                        </Box>

                        {/* growth stage */}
                        <Box sx={{ display: "flex", alignItems: "center", marginTop: '32px' }}>
                          <MuiNestedSubDropDown
                            label={intl.formatMessage({ id: 'DEVELOPMENT_STAGE_ST' })}
                            options={growthStageDropdowns}
                            defaultValue={growthStageValue}
                            onChange={(value) => handleFieldChange('growthStageNested', value)}
                          />
                        </Box>

                        {/* Weather and Wind */}
                        <Box sx={{ display: "flex", gap: '16px', paddingTop: '56px', alignItems: "center" }}>
                          <MuiSelectDropdown
                            defaultLabel={intl.formatMessage({ id: 'WEATHER' })}
                            defaultValue={formState.weather}
                            options={weatherOptions}
                            fieldName='weather'
                            onChange={handleFieldChange}
                            autoFocus={false}
                            activityId="act19"
                            showEmptySpace={false}
                          />
                          <MuiSelectDropdown
                            defaultLabel={intl.formatMessage({ id: 'WIND' })}
                            defaultValue={formState.taskActivity?.windSpeed || ''}
                            inputAdornment={intl.formatMessage({ id: 'WIND_UNIT' })}
                            fieldName="windSpeed"
                            options={getWindSpeedOptions()}
                            autoFocus={false}
                            onChange={handleFieldChange}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: '250px',
                                },
                              },
                            }}
                            activityId="act19"
                            showEmptySpace={false}
                          />
                        </Box>

                        {/* Vehicle */}
                        <Box sx={{ display: "flex", alignItems: "center", paddingTop: '56px' }}>
                          <MuiSelectDropdown
                            key={createdVehicleId}
                            defaultLabel={intl.formatMessage({ id: 'VEHICLE' })}
                            defaultValue={formState.vehicleAssetId}
                            options={vehicleOptions()}
                            fieldName="vehicleAssetId"
                            onChange={handleFieldChange}
                            activityId="act19"
                            showEmptySpace={false}
                          />
                        </Box>

                        {/* Equipment */}
                        <Box sx={{ display: "flex", alignItems: "center", paddingTop: '24px' }}>
                          <MuiSelectDropdown
                            key={createdEquipmentId}
                            defaultLabel={intl.formatMessage({ id: 'EQUIPMENT' })}
                            defaultValue={formState.equipmentAssetId}
                            options={equipmentOptions()}
                            fieldName="equipmentAssetId"
                            onChange={handleFieldChange}
                            activityId="act19"
                            showEmptySpace={false}
                          />
                        </Box>

                        {/* Performed By */}
                        <Box sx={{ display: "flex", alignItems: "center", paddingTop: '56px' }}>
                          <MuiTextField
                            defaultLabel={intl.formatMessage({ id: 'PERFORMED_BY' })}
                            defaultValue={formState.taskActivity?.performedBy || ''}
                            fieldName="performedBy"
                            onChange={handleFieldChange}
                          />
                        </Box>
                      </Box>
                    }
                  />
                </Box>
              </>
            </Box>
            <Box sx={{ display: isSecondSelected ? 'block' : 'none' }}>
              <AddTaskWaterJournalTemplate2
                onFieldChange={handleFieldChange}
                formData={formState}
                initialData={initialFormState}
                formErrors={formErrors}
                onCloseVehicleDialog={onCloseVehicleDialog}
                handleNumericValidation={handleNumericValidation}
                vehicleOptions={vehicleOptions}
                intl={intl}
                activeFarm={activeFarm}
                selectedFields={selectedFields}
                selectedActivity={selectedActivity}
                taskDetails={taskDetails}
                closeNewTask={closeNewTask}
                saveNewTask={saveNewTask}
                createdVehicleId={createdVehicleId}
                createdEquipmentId={createdEquipmentId}
                fieldMasterData={fieldMasterData}
                activitiesCommon={activitiesCommon}
                taskKartToggle={taskKartToggle}
                waterJournal={formState.waterJournal}
                waterJournalAdded={formState.waterJournalAdded}
                openTimerDialog={openTimerDialog}
                handleCancelTimerButton={handleCancelTimerButton}
                handleOkTimerButton={handleOkTimerButton}
                handleHoursChange={handleHoursChange}
                handleMinutesChange={handleMinutesChange}
                currentTimerHourValue={timerHourValue}
                currentTimerMinutesValue={timerMinutesValue}
                isTimerOpen={isTimerOpen}
              />
            </Box>
          </Box>
        )
      }
      <Box sx={{ display: !isWaterJournalAdded ? 'block' : 'none' }}>
        <AddTaskTemplateNonWaterJournal
          onFieldChange={handleFieldChange}
          formData={formState}
          initialData={initialFormState}
          formErrors={formErrors}
          handleNumericValidation={handleNumericValidation}
          vehicleOptions={vehicleOptions}
          equipmentOptions={equipmentOptions}
          waterUnitOptions={waterUnitOptions}
          getWindSpeedOptions={getWindSpeedOptions}
          weatherOptions={weatherOptions}
          onCloseEquipmentDialog={onCloseEquipmentDialog}
          onCloseVehicleDialog={onCloseVehicleDialog}
          intl={intl}
          activeFarm={activeFarm}
          selectedFields={selectedFields}
          selectedActivity={selectedActivity}
          taskDetails={taskDetails}
          createdVehicleId={createdVehicleId}
          createdEquipmentId={createdEquipmentId}
          fieldMasterData={fieldMasterData}
          activitiesCommon={activitiesCommon}
          taskKartToggle={taskKartToggle}
          openTimerDialog={openTimerDialog}
          handleCancelTimerButton={handleCancelTimerButton}
          handleOkTimerButton={handleOkTimerButton}
          handleHoursChange={handleHoursChange}
          handleMinutesChange={handleMinutesChange}
          currentTimerHourValue={timerHourValue}
          currentTimerMinutesValue={timerMinutesValue}
          isTimerOpen={isTimerOpen}
        />
      </Box>
      <Box style={taskTemplateStyle.buttonBox}>
        {isFailure && !isSuccess ? (
          <Typography
            variant="body2"
            color="error"
            className="full-width task-message error"
            sx={{ backgroundColor: 'transparent' }}
          >
            {errorMessage?.data == null ? (
              <FormattedMessage id="COMMON_ERR_MSG" />
            ) : (
              errorMessage.data
            )}
          </Typography>
        ) : ''}
        {notSelectedError && (
          <div className="task-pesticide-check-agreement-error" style={{ padding: '0 10px' }}>
            <Typography sx={{ color: 'red', fontSize: '13px', marginTop: '10px' }}>
              {intl.formatMessage({ id: 'SELECT_REGULATION' })}
            </Typography>
          </div>
        )}
        <Box style={taskTemplateStyle.buttonBoxBottom}>
          <Chip
            label={intl.formatMessage({ id: 'cancel' })}
            clickable
            style={taskTemplateStyle.cancelButtonStyle}
            sx={{
              backgroundColor: 'transparent',
              '&:hover, &:focus': {
                backgroundColor: 'transparent',
              }
            }}
            disableRipple
            onClick={handleCancel}
          />
          <Chip
            label={intl.formatMessage({ id: isEditMode ? 'update' : 'SAVE' })}
            clickable
            sx={{
              fontFamily: 'Inter',
              fontWeight: 500,
              height: '40px',
              borderRadius: '100px',
              padding: '0px 10px',
              fontSize: 14,
              color: (!isEditMode || hasChanges) ? '#ffffff' : '#111111',
              backgroundColor: (!isEditMode || hasChanges) ? '#00696D' : '#999999',
              '&:hover, &:focus': {
                backgroundColor: (!isEditMode || hasChanges) ? '#00696D' : '#999999',
              }
            }}
            disableRipple
            disabled={(isEditMode && !hasChanges)}
            onClick={handleSave}
          />
        </Box>
      </Box>
      {/* Modal */}
      <Box>
        <TimerModal
          intl={intl}
          isTimerOpen={isTimerOpen}
          handleCancelTimerButton={handleCancelTimerButton}
          handleOkTimerButton={handleOkTimerButton}
          handleHoursChange={handleHoursChange}
          handleMinutesChange={handleMinutesChange}
          formErrors={formErrors}
          formState={formState}
        />
      </Box>
      <Box>
        <Dialog
          onClose={() => { }}
          open={isModalOpen}
          PaperProps={{
            style: {
              backgroundColor: '#E6E9E8',
              borderRadius: "28px",
              width: "312px",
              minWidth: "280px",
              maxWidth: "312px",
              maxHeight: '30vh'
            }
          }}
        >
          <Box style={taskTemplateStyle.cancelModalBox}>
            <Typography style={taskTemplateStyle.cancelModalTitle}>
              {intl.formatMessage({ id: isEditMode ? 'CANCEL_WITHOUT_SAVING' : 'TASK_CANCEL_MODAL_TITLE' })}
            </Typography>
            <Typography style={taskTemplateStyle.cancelModalSubTitle}>{intl.formatMessage({ id: isEditMode ? 'UPDATES_NOT_SAVED' : 'TASK_CANCEL_MODAL_SUB_TITLE' })}
            </Typography>
          </Box>
          <Box style={taskTemplateStyle.cancelModalBoxButton}>
            <Chip
              label={intl.formatMessage({ id: 'cancel' })}
              clickable
              style={taskTemplateStyle.cancelButtonStyle}
              sx={{
                backgroundColor: 'transparent',
                '&:hover, &:focus': {
                  backgroundColor: 'transparent',
                }
              }}
              disableRipple
              onClick={handleCancelButton}
            />
            <Chip
              label={intl.formatMessage({
                id: isEditMode ? 'FORGET_UPDATE' : 'TASK_CONTINUE_REGISTRATION'
              })}
              clickable
              style={taskTemplateStyle.cancelButtonStyle}
              sx={{
                backgroundColor: 'transparent',
                '&:hover, &:focus': {
                  backgroundColor: 'transparent',
                }
              }}
              disableRipple
              onClick={handleContinueSave}
            />
          </Box>
        </Dialog>
      </Box>
      <AddVehicleModal
        intl={intl}
        vehicleSelectedId={'new'}
        onCloseVehicleDialog={onCloseVehicleDialog}
        showAddVehicleDialog={showAddVehicleDialog}
        assetType={'vehicle'}
        taskDetails={taskDetails}
      />
      <AddEquipmentModal
        intl={intl}
        equipmentSelectedId={'new'}
        onCloseEquipmentDialog={onCloseEquipmentDialog}
        showAddEquipmentDialog={showAddEquipmentDialog}
        assetType={'equipment'}
        taskDetails={taskDetails}
      />
    </Box >
  );
};

export default AddTaskTemplate3;